export function findRelativeParent(targetElement: Element) {
  if (targetElement.getRootNode() === targetElement) {
    return undefined;
  }

  let targetParent: Element | ShadowRoot | null = targetElement.parentElement;

  while (targetParent) {
    if (targetParent instanceof ShadowRoot) {
      targetParent = targetParent.host;

      continue;
    }

    const { position } = getComputedStyle(targetParent);

    if (['fixed', 'relative', 'absolute'].includes(position)) {
      return targetParent;
    }

    targetParent = targetParent.parentElement;
  }

  return document.documentElement;
}
